const converters = {
  rem: (value, baseSize) => value * parseFloat(baseSize),
  em: (value, baseSize) => value * parseFloat(baseSize),
  px: (value) => value,
};

export const convert = (object, baseSize) => {
  const converter = converters[object.unit];

  if (converter) {
    return converter(object.value, baseSize);
  }

  return 0;
};
